import { Button } from 'antd';
import { createContext, useContext } from 'react';
import { AppearanceSwitcher } from './AppearanceProvider';

export const WorkspaceLogoutContext = createContext<(() => void) | null>(null);

export function WorkspaceShellActions() {
  const logout = useContext(WorkspaceLogoutContext);
  return (
    <>
      <AppearanceSwitcher />
      <Button onClick={() => logout?.()}>退出登录</Button>
    </>
  );
}
